


import { useState } from 'react';
import { PageHead } from '../../components/ui.tsx';






import { CapitalHero } from './hero.tsx';
import { GoalsSection } from './goals.tsx';
import { EventsSection } from './events.tsx';
import { FinplanSection } from './projection.tsx';

export function PlanPage() {
  // one chosen year for the summary and the chart; null means the plan's last year
  const [year, setYear] = useState<number | null>(null);
  return (
    <div className="page">
      <PageHead title="Капитал" />
      <CapitalHero year={year} onYear={setYear} />
      <div className="grid-2">
        <GoalsSection />
        <EventsSection />
      </div>
      <FinplanSection year={year} onYear={setYear} />
    </div>
  );
}
